
export enum TaskStatus {
  DESIGNATE = 10, // 待指派
  PROCESSING = 20, // 进行中
  CHANGED = 30, // 已变更
  COMPLETED = 40, // 已完成
  CLOSE = 50, // 已关闭
}

/**
 * @description 标签类型
 */
export enum LabelType {
  /** 系统标签 */
  System = 1,
  /** 网规标签 */
  NetPlan = 2,
  /** 自定义标签 */
  Custom = 3
}

/** 网规标签（A类、B类、C类、D类） */
export const labelType = [
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/label/label_A@2x.png`,
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/label/label_B@2x.png`,
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/label/label_C@2x.png`,
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/label/label_D@2x.png`,
];

/**
 * 网规标签名称与图片对应map
 * @description 使用方法：
  拿到标签名称label后，
  const imgUrl = typeLabelImgMap.get(label) || ''
 */
export const typeLabelImgMap = new Map([
  ['A类', labelType[0]],
  ['B类', labelType[1]],
  ['C类', labelType[2]],
  ['D类', labelType[3]],
]);

// 非商场类型本品牌门店
export const targetStandardShop: string[] = [
  'STANDARD_SHOP'
];
// 非商场类型机会点
export const targetChancepoint: string[] = [
  'CHANCE_POINT'
];

// 非商场类型经营门店
export const targetShops: string[] = [
  'FAMOUS_BRAND', // 知名品牌
  'COMPETITORS', // 竞品门店
  'RESTAURANT', // 餐饮
  'SHOPPING', // 购物
  'LIFE_SERVICE', // 生活服务
  'EDUCATION', // 教育培训
  'RECREATION', // 休闲娱乐
  'FITNESS', // 运动健身
  'HOTEL', // 酒店住宿
  'VEHICLE_SERVICE', // 汽车服务
];

// 商场类型本品牌门店
export const targetMallStandardShop: string[] = [
  'MALL_STANDARD_SHOP'
];
// 商场类型机会点
export const targetMallChancepoint: string[] = [
  'MALL_CHANCE_POINT'
];

// 商场类型经营门店
export const targetMallShops: string[] = [
  'MALL_FAMOUS_BRAND',
  'MALL_COMPETITORS',
  'MALL_RESTAURANT',
  'MALL_SHOPPING',
  'MALL_LIFE_SERVICE',
  'MALL_EDUCATION',
  'MALL_RECREATION',
  'MALL_FITNESS',
  'MALL_HOTEL',
  'MALL_VEHICLE_SERVICE',
];

// 周边配套
export const targetSurrounding: string[] = [
  'ZHU_ZHAI',
  'GOU_WU',
  'BAN_GONG',
  'XUE_XIAO',
  'YI_LIAO',
  'JIAO_TONG',
  'JING_QU',
];

export const targetLegendIcon = {
  // 集客点
  'GATHER_CLIENT': `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/selectionmap/sitemap_gatherclient_pointTextNew.png`,
  // 本品牌门店
  'STANDARD_SHOP': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_standardshop.png`,
  'MALL_STANDARD_SHOP': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_standardshop.png`,
  // 机会点
  'CHANCE_POINT': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_chancepoint.png`,
  'MALL_CHANCE_POINT': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_chancepoint.png`,
  // 非商场经营门店：
  'FAMOUS_BRAND': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_famous_brand.png`,
  'COMPETITORS': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_competitor.png`,
  'RESTAURANT': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_catering.png`,
  'SHOPPING': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_shopping.png`,
  'LIFE_SERVICE': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_service_life.png`,
  'EDUCATION': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_education.png`,
  'RECREATION': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_recreation.png`,
  'FITNESS': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_exercise.png`,
  'HOTEL': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_hotel.png`,
  'VEHICLE_SERVICE': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_car.png`,
  // 商场经营门店：
  'MALL_FAMOUS_BRAND': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_famous_brand.png`,
  'MALL_COMPETITORS': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_competitor.png`,
  'MALL_RESTAURANT': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_catering.png`,
  'MALL_SHOPPING': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_shopping.png`,
  'MALL_LIFE_SERVICE': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_service_life.png`,
  'MALL_EDUCATION': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_education.png`,
  'MALL_RECREATION': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_recreation.png`,
  'MALL_FITNESS': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_exercise.png`,
  'MALL_HOTEL': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_hotel.png`,
  'MALL_VEHICLE_SERVICE': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_car.png`,
  // 周边配套
  'ZHU_ZHAI': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_housing.png`,
  'GOU_WU': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_business.png`,
  'BAN_GONG': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_work.png`,
  'XUE_XIAO': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_school.png`,
  'YI_LIAO': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_hospital.png`,
  'JIAO_TONG': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_traffic.png`,
  'JING_QU': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_scenic.png`,
};

// 选址地图详情中新的经营门店图例
export const detailTargetLegendIcon = {
  // 非商场型
  'FAMOUS_BRAND': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_famous_brand@3x.png`,
  'COMPETITORS': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_competitor@3x.png`,
  'RESTAURANT': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_catering@3x.png`,
  'SHOPPING': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_shopping@3x.png`,
  'LIFE_SERVICE': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_service_life@3x.png`,
  'EDUCATION': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_education@3x.png`,
  'RECREATION': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_recreation@3x.png`,
  'FITNESS': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_exercise@3x.png`,
  'HOTEL': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_hotel@3x.png`,
  'VEHICLE_SERVICE': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_car@3x.png`,
  // 商场型
  'MALL_FAMOUS_BRAND': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_famous_brand@3x.png`,
  'MALL_COMPETITORS': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_competitor@3x.png`,
  'MALL_RESTAURANT': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_catering@3x.png`,
  'MALL_SHOPPING': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_shopping@3x.png`,
  'MALL_LIFE_SERVICE': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_service_life@3x.png`,
  'MALL_EDUCATION': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_education@3x.png`,
  'MALL_RECREATION': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_recreation@3x.png`,
  'MALL_FITNESS': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_exercise@3x.png`,
  'MALL_HOTEL': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_hotel@3x.png`,
  'MALL_VEHICLE_SERVICE': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_car@3x.png`,
};

// 选址地图首页中显示的图例
export const homeTargetLegendIcon = {
  'BRAND': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_legend_brand.png`,
  'COLLECT': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_legend_collect.png`,
  'OPEN_AREA': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_legend_open_area.png`,
  'OPENED': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_legend_opened.png`,
  'POINT': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_legend_point.png`,
  'SUBWAY': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_legend_subway.png`,
  'PROTECT': `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/selectionmap/icon_site_areaProtect.png`,
  'COMMUNITY': `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_housing.png`
};

/**
 * @description 开业状态（后端约定的字符串值）
 *   以下接口返回该值
 *   /youth/map/modelCluster/overview/base 返回的openStatus
 *   /youth/map/modelCluster/detail 返回的placeBaseInfo.openStatus
 */
export enum OpenStatus {
  WaitOpen = '未开业',
  Opened = '已开业',
}

